import { call, put, takeLatest } from "redux-saga/effects";
import get from "lodash/get";
import Request from "common/network/http/Request";
import BidActions, { BidDetailsTypes } from "reducers/BidDetailsRedux";
import endpoints from "configs/endpoints";
import { history } from "store";

function* handleFetchBid(action) {
  const { id } = action;

  try {
    const result = yield call(Request.get.bind(Request), endpoints.biddings.getBiddingDetail(id));
    const error = get(result, "data.error");

    if (!error) {
      yield put(BidActions.fetchBidDetailsSuccess(result));
    } else {
      if (error === "Bid not found") {
        yield call(history.push, "/my-account/bidding/my-bid");
      }
      yield put(BidActions.fetchBidDetailsFailure());
    }
  } catch (err) {
    yield put(BidActions.fetchBidDetailsFailure());
  }
}

export default function* () {
  return [
    yield takeLatest(BidDetailsTypes.FETCH_BID_DETAILS, handleFetchBid),
  ];
}
